import { render, staticRenderFns } from "./ClubsGlobal.vue?vue&type=template&id=885f2bee&scoped=true"
import script from "./ClubsGlobal.vue?vue&type=script&lang=js"
export * from "./ClubsGlobal.vue?vue&type=script&lang=js"
import style0 from "./ClubsGlobal.vue?vue&type=style&index=0&id=885f2bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885f2bee",
  null
  
)

export default component.exports